/* eslint-disable  */
import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Avatar, Badge, IconButton } from "@material-ui/core";
import { MessageSharp, NotificationImportant } from "@material-ui/icons";
import {
  Menu,
  X,
  Home,
  Users,
  Layers,
  Package,
  ShoppingCart,
  CheckCircle,
  Truck,
  XCircle,
  BarChart2,
  LogOut,
  ClipboardList,
  Tag,
  ChevronLeft,
} from "lucide-react";

// Redux Actions
import { GetUserProfile, SignOut } from "../services/Actions/authActions";
import { GetMartOfficersMessagesUnread } from "../services/Actions/MessagesAction";
import { GetNotificationsByMartOfficers } from "../services/Actions/notificationAction";
import ThemeToggle from "../Components/ThemeToggle";

function RenderHirePurchasePage({ children, title }) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);
  const message = useSelector((state) => state?.message);
  const { mart_notifications } = useSelector((state) => state?.notification);
  const { user } = auth;

  useEffect(() => {
    dispatch(GetUserProfile());
    dispatch(GetMartOfficersMessagesUnread());
    dispatch(GetNotificationsByMartOfficers());
  }, [dispatch]);

  const handleLogout = () => {
    dispatch(SignOut());
    setTimeout(() => window.location.reload(false), 500);
  };

  const navItems = [
    { label: "Dashboard", icon: <Home size={18} />, path: "/mart/home" },
    {
      label: "Mart Deductions",
      icon: <Layers size={18} />,
      path: "/mart/mart-deduction",
    },
    {
      label: "Non-Members IM",
      icon: <Users size={18} />,
      // path: "/mart/non-member-im",
    },
    {
      label: "Non-Members CDD",
      icon: <ClipboardList size={18} />,
      // path: "/mart/non-member-cdd",
    },
    { label: "Suppliers", icon: <Users size={18} />, path: "/mart/vendors" },
    { label: "Category", icon: <Tag size={18} />, path: "/mart/category" },
    { label: "Products", icon: <Package size={18} />, path: "/mart/product" },
    { label: "Orders", icon: <ShoppingCart size={18} />, path: "/mart/order" },
    {
      label: "Requested Orders",
      icon: <ClipboardList size={18} />,
      path: "/mart/request-order",
    },
    {
      label: "Booked Order",
      icon: <CheckCircle size={18} />,
      path: "/mart/processed-order",
    },
    {
      label: "Approved Order",
      icon: <CheckCircle size={18} />,
      path: "/mart/approved-order",
    },
    {
      label: "Shipped Order",
      icon: <Truck size={18} />,
      path: "/mart/shipped-order",
    },
    {
      label: "Rejected Order",
      icon: <XCircle size={18} />,
      path: "/mart/rejected-order",
    },
    {
      label: "Status of orders",
      icon: <BarChart2 size={18} />,
      path: "/mart/status-order",
    },
    { label: "Report", icon: <BarChart2 size={18} />, path: "/mart/report" },
  ];

  const NavLink = ({ item }) => {
    const isActive = location.pathname === item.path;
    return (
      <button
        onClick={() => {
          history.push(item.path);
          setIsMobileMenuOpen(false);
        }}
        title={isCollapsed ? item.label : ""}
        className={`w-full flex items-center ${isCollapsed ? "justify-center" : "gap-3"} px-3 py-3 rounded-md transition-all duration-200 group ${isActive
            ? "bg-indigo-600 text-white shadow-md shadow-indigo-200 dark:shadow-indigo-900"
            : "text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-gray-800 hover:text-indigo-600 dark:hover:text-indigo-400"
          }`}
      >
        <span
          className={`flex-shrink-0 ${isActive
              ? "text-white"
              : "text-slate-400 dark:text-slate-500 group-hover:text-indigo-600 dark:group-hover:text-indigo-400"
            }`}
        >
          {item.icon}
        </span>
        {!isCollapsed && <span className="text-sm font-semibold">{item.label}</span>}
      </button>
    );
  };

  const sidebarWidth = isCollapsed ? "w-[68px]" : "w-72";
  const mainPadding = isCollapsed ? "lg:pl-[68px]" : "lg:pl-72";

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900 flex py-1 transition-colors duration-300">
      {/* SIDEBAR */}
      <aside
        className={`
        fixed inset-y-0 left-0 z-50 ${sidebarWidth} bg-white dark:bg-gray-900 border-r border-slate-200 dark:border-gray-700 transform transition-all duration-300 ease-in-out
        lg:translate-x-0 ${isMobileMenuOpen ? "translate-x-0 !w-72" : "-translate-x-full"}
      `}
      >
        <div className="h-full flex flex-col">
          {/* Logo Section */}
          <div className="p-3 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="w-6 h-6 bg-indigo-600 rounded-lg flex items-center justify-center text-white font-bold flex-shrink-0">
                M
              </div>
              {!isCollapsed && (
                <span className="text-md font-bold text-slate-800 dark:text-slate-100">
                  Mart Admin
                </span>
              )}
            </div>
            <button
              onClick={() => setIsCollapsed(!isCollapsed)}
              className="hidden lg:flex p-1.5 rounded-lg border border-slate-200 dark:border-gray-600 text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-gray-800 transition-colors"
            >
              <ChevronLeft
                size={16}
                style={{
                  transform: isCollapsed ? "rotate(180deg)" : "none",
                  transition: "transform 0.3s",
                }}
              />
            </button>
            <button
              onClick={() => setIsMobileMenuOpen(false)}
              className="lg:hidden p-2 text-slate-500 dark:text-slate-400"
            >
              <X size={20} />
            </button>
          </div>

          {/* Navigation Links */}
          <nav className="flex-1 px-2 py-1 overflow-y-auto space-y-1 custom-scrollbar">
            {navItems.map((item) => (
              <NavLink key={item.path} item={item} />
            ))}
          </nav>

          {/* User Profile Footer */}
          <div className="p-2 border-t border-slate-100 dark:border-gray-700 bg-slate-50/50 dark:bg-gray-800/50">
            {!isCollapsed ? (
              <>
                <div className="flex items-center gap-2 mb-2 px-2">
                  <img
                    className="w-8 h-8 rounded-full border-2 border-white dark:border-gray-600 shadow-sm flex-shrink-0"
                    src={user?.profile_image || "/images/dev/avatar1.png"}
                    alt="User"
                  />
                  <div className="overflow-hidden">
                    <p className="text-xs font-bold text-slate-800 dark:text-slate-100 truncate">
                      {user?.name || "Mart Officer"}
                    </p>
                    <p className="text-xs text-slate-500 dark:text-slate-400 truncate">Mart Officer</p>
                  </div>
                </div>
                <button
                  onClick={handleLogout}
                  className="w-full flex items-center justify-center gap-2 px-2 py-2 bg-white dark:bg-gray-800 border border-slate-200 dark:border-gray-600 text-rose-600 rounded-xl hover:bg-rose-50 dark:hover:bg-gray-700 hover:border-rose-100 dark:hover:border-gray-500 transition-colors font-semibold text-sm shadow-sm"
                >
                  <LogOut size={16} />
                  Logout
                </button>
              </>
            ) : (
              <button
                onClick={handleLogout}
                title="Logout"
                className="w-full flex items-center justify-center py-2 text-rose-600 hover:bg-rose-50 dark:hover:bg-gray-700 rounded-xl transition-colors"
              >
                <LogOut size={18} />
              </button>
            )}
          </div>
        </div>
      </aside>

      {/* MAIN CONTENT AREA */}
      <main className={`flex-1 flex flex-col min-w-0 ${mainPadding} transition-all duration-300`}>
        {/* TOP BAR */}
        <header className="sticky top-0 z-40 bg-white/60 dark:bg-gray-900/60 backdrop-blur-md border-b border-slate-200 dark:border-gray-700 px-4 sm:px-3 lg:px-4 py-2 transition-colors duration-300">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <button
                onClick={() => setIsMobileMenuOpen(true)}
                className="lg:hidden p-2 rounded-lg bg-slate-100 dark:bg-gray-800 text-slate-600 dark:text-slate-300"
              >
                <Menu size={18} />
              </button>
              <h1 className="text-md font-bold text-slate-800 dark:text-slate-100 hidden sm:block">
                {title || "Dashboard"}
              </h1>
            </div>

            <div className="flex items-center gap-2 sm:gap-4">
              <ThemeToggle />

              <IconButton onClick={() => history.push("/mart/messages")}>
                <Badge
                  badgeContent={message?.martMessagesUnread}
                  color="secondary"
                >
                  <MessageSharp className="text-slate-500 dark:text-slate-400" />
                </Badge>
              </IconButton>

              <IconButton onClick={() => history.push("/mart/notifications")}>
                <Badge
                  badgeContent={mart_notifications?.length}
                  color="secondary"
                >
                  <NotificationImportant className="text-slate-500 dark:text-slate-400" size={16} />
                </Badge>
              </IconButton>

              <div className="h-8 w-px bg-slate-200 dark:bg-gray-600 mx-1 hidden sm:block"></div>

              <img
                onClick={() => history.push("/mart/profile")}
                className="w-7 h-7 rounded-full cursor-pointer ring-2 ring-transparent hover:ring-indigo-500 transition-all shadow-sm"
                src={user?.profile_image || "/images/dev/avatar1.png"}
                alt="Avatar"
              />
            </div>
          </div>
        </header>

        {/* PAGE CONTENT */}
        <div className="p-4 sm:p-6 lg:p-8">
          <div className="mb-6">
            <h2 className="text-2xl font-black text-slate-800 dark:text-slate-100 tracking-tight">
              {title}
            </h2>
            {title && (
              <div className="h-1 w-12 bg-indigo-600 rounded-full mt-2"></div>
            )}
          </div>
          <div className="animate-in fade-in duration-500">{children}</div>
        </div>
      </main>

      {/* MOBILE OVERLAY */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-slate-900/40 dark:bg-black/50 backdrop-blur-sm z-40 lg:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </div>
  );
}

export default RenderHirePurchasePage;
